import type { VoidFunctionComponent } from 'react';

import type { IconClassName } from '../../generic';
import { Badge, BadgeColors, icons } from '../../generic';
import type { PackageLabelAssignmentWithName } from '../../../../shared/model-typings/packagelabelassignment';

type Props = {
  label: PackageLabelAssignmentWithName;
  hasDarkBackground?: boolean;
};

/**
 * A badge that displays a Package Label's scope and name.
 */
const PackageLabelBadge: VoidFunctionComponent<Props> = ({ label, hasDarkBackground = false }) => {
  let icon: IconClassName = icons.globeOutline;
  if (label.scope === 'project') {
    icon = icons.folderBookmark;
  } else if (label.scope === 'revision') {
    icon = icons.codeCommit;
  }

  const color = hasDarkBackground ? BadgeColors.DarkGray : BadgeColors.White;

  return (
    <Badge color={color} icon={icon} fullWidth>
      {label.name}
    </Badge>
  );
};

export default PackageLabelBadge;
